module.exports = __webpack_public_path__ + "img/multi.097942cb.svg";